import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { instalarCapturaDeErrores } from "./shared/errors/install";
import "./styles/globals.css";

/*
 * Lo PRIMERO, antes de tocar el DOM: un error al arrancar —un chunk que no
 * bajó, un módulo que revienta al importarse— ocurre antes de que exista un
 * solo componente, y la red de React no lo ve. Este sí.
 */
instalarCapturaDeErrores();

const container = document.getElementById("root");
if (!container) {
  throw new Error('No existe #root en index.html — no hay dónde montar la app.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
